import { PDFExport } from "@progress/kendo-react-pdf";
import PageMain from "./PageMain";
import { PageTwo } from "./PageTwo";

const ForPdf = ({
  pdfExportComponent,
  reportDetails,
  reportChartRadonValue,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "-9999px",
        left: "-9999px"
      }}
    >
      <PDFExport paperSize="Letter" ref={pdfExportComponent}>
        <div id="pdfRoot">
          <div
            className="pdf-body"
            style={{
              height: "100%",
              padding: "25px 25px 5px",
              border: "1px solid #E6E8F0",
              backgroundColor: "white",
            }}
          >
            <PageMain
              reportDetails={reportDetails}
              reportChartRadonValue={reportChartRadonValue}
              isForPDF={true}
            />
          </div>
          {/*<div*/}
          {/*  className="pdf-body"*/}
          {/*  style={{*/}
          {/*    height: "100%",*/}
          {/*    padding: "25px 25px 5px",*/}
          {/*    border: "1px solid #E6E8F0",*/}
          {/*    backgroundColor: "white",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <PageTwo*/}
          {/*    reportDetails={reportDetails}*/}
          {/*    reportChartRadonValue={reportChartRadonValue}*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
      </PDFExport>
    </div>
  );
};

export default ForPdf;
